import { trackPromise } from 'react-promise-tracker';

export async function validateUser(CUI) {
    return trackPromise(fetch('https://t41bx8uqf6.execute-api.us-east-2.amazonaws.com/prod/votacion/validardatos', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'authorizationToken': 'Allow'
        },
        body: JSON.stringify({"CUI":CUI})
    }).then(data => data.json()))
}